import Component from './Component';

/**
 * 瓦片管理器
 */
export default class TileManager extends Component {
    constructor(options) {
        super(options);

        this.tileSize = this.options.tileSize || 256;
    }

    getTiles(tileSize = this.tileSize, pixelBounds) {
        let bounds = pixelBounds;
        if (!bounds) {
            // bounds = this._map.getPixelBounds();
            const zoom = this._map.getZoomLevel();
            bounds = this._map.getBounds();
            const min = this._map.project(bounds.getNorthWest(), zoom);
            const max = this._map.project(bounds.getSouthEast(), zoom);
            bounds = L.bounds(min, max);
        }

        const tileBounds = L.bounds(
            bounds.min.divideBy(tileSize)._floor(),
            bounds.max.divideBy(tileSize)._floor()
        );

        return this._getTilesFromCenterOut(tileBounds, tileSize);
    }

    _getTilesFromCenterOut(bounds, tileSize) {
        const tiles = {};
        const queue = [];
        const center = bounds.getCenter();
        const zoom = this._map.getZoomLevel();

        for (let j = bounds.min.y; j <= bounds.max.y; j++) {
            for (let i = bounds.min.x; i <= bounds.max.x; i++) {
                const point = new L.Point(i, j);
                queue.push(point);
            }
        }

        // load tiles in order of their distance to center
        queue.sort((a, b) => a.distanceTo(center) - b.distanceTo(center));

        for (let i = 0; i < queue.length; i++) {
            const x = queue[i].x;
            const y = queue[i].y;
            const tile = this._createTile(x, y, zoom, tileSize);
            tiles[tile.name] = tile;
        }

        return tiles;
    }

    _createTile(x, y, z, tileSize) {
        return {
            name: `${x}:${y}:${z}`,
            x: x,
            y: y,
            z: z,
            size: tileSize
        };
    }

    getTileBoundsGeo(tile) {
        const pixelBounds = this.getTilePixelBounds(tile);
        const zoom = this._map.getZoomLevel();
        const nw = this._map.unproject(pixelBounds.min, zoom);
        const se = this._map.unproject(pixelBounds.max, zoom);

        const bounds = {
            type: 'Polygon',
            coordinates: [
                [
                    [nw.lng, nw.lat],
                    [se.lng, nw.lat],
                    [se.lng, se.lat],
                    [nw.lng, se.lat],
                    [nw.lng, nw.lat]
                ]
            ]
        };

        return bounds;
    }

    getTilePixelBounds(tile) {
        const tilePoint = new L.Point(tile.x, tile.y);
        const nwPoint = tilePoint.multiplyBy(tile.size);
        const sePoint = nwPoint.add([tile.size, tile.size]);

        return L.bounds(nwPoint, sePoint);
    }

    getTilebbox(tile) {
        const pixelBounds = this.getTilePixelBounds(tile);
        const zoom = this._map.getZoomLevel();
        const nw = this._map.unproject(pixelBounds.min, zoom);
        const se = this._map.unproject(pixelBounds.max, zoom);

        return [nw.lng, se.lat, se.lng, nw.lat];
    }
}
